import { createUniqueId } from 'solid-js'

export function TripleCoinIcon() {
  // Minted per instance, so copies of one icon never resolve url(#…) to
  // each other's defs
  const id = createUniqueId()
  const paint0 = `triple-coin-icon-${id}-paint0`
  const paint1 = `triple-coin-icon-${id}-paint1`
  const paint2 = `triple-coin-icon-${id}-paint2`
  const paint3 = `triple-coin-icon-${id}-paint3`

  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M23 41.27C12.91 41.27 4.72 33.07 4.72 23C4.72 12.93 12.91 4.71997 23 4.71997C33.09 4.71997 41.28 12.92 41.28 23C41.28 33.08 33.08 41.28 23 41.28V41.27Z"
        fill={`url(#${paint0})`}
      />
      <path
        d="M37.6146 25.0892C37.6242 25.1563 37.6242 25.2329 37.6242 25.3C37.6242 32.1138 31.0787 37.6338 22.9904 37.6338C14.9021 37.6338 8.36624 32.1138 8.36624 25.3C8.36624 25.2329 8.36624 25.1563 8.37583 25.0892H8.36624V20.5371H37.6146V25.0892Z"
        fill={`url(#${paint1})`}
      />
      <path
        d="M23 33.0337C31.0787 33.0337 37.6242 27.5137 37.6242 20.7C37.6242 13.8862 31.0787 8.36621 23 8.36621C14.9212 8.36621 8.37582 13.8862 8.37582 20.7C8.37582 27.5137 14.9212 33.0337 23 33.0337Z"
        fill={`url(#${paint2})`}
      />
      <path
        d="M23 29.8425C28.98 29.8425 33.8388 25.7504 33.8388 20.7096C33.8388 15.6687 28.9896 11.5767 23 11.5767C17.0104 11.5767 12.1613 15.6687 12.1613 20.7096C12.1613 25.7504 17.0104 29.8425 23 29.8425Z"
        fill={`url(#${paint3})`}
      />
      <path
        d="M19.723 24.1518C18.8039 24.1518 18.048 23.9456 17.524 23.5505C17.1632 23.2756 17 22.975 17 22.6142C17 22.0645 17.3952 21.6865 17.9535 21.6865C18.2112 21.6865 18.4775 21.7896 18.7438 21.9871C19.0187 22.1761 19.3279 22.262 19.7316 22.262C20.2212 22.262 20.582 21.9614 20.582 21.5662C20.582 21.1367 20.2126 20.8791 19.5856 20.8791H19.1046C18.572 20.8791 18.1683 20.5011 18.1683 19.9943C18.1683 19.4875 18.572 19.1095 19.1046 19.1095H19.5598C20.058 19.1095 20.393 18.869 20.393 18.5168C20.393 18.1646 20.0752 17.8984 19.6285 17.8984C19.2935 17.8984 19.0444 18.0358 18.8125 18.1732C18.5977 18.3107 18.4174 18.3622 18.2026 18.3622C17.6958 18.3622 17.3093 17.9585 17.3093 17.4259C17.3093 17.2284 17.378 16.9277 17.7302 16.6442C18.2026 16.2577 19.0101 16 19.7832 16C21.3637 16 22.4288 16.8762 22.4288 18.1904C22.4288 18.869 22.1368 19.4789 21.6214 19.8654C22.3 20.2606 22.6694 20.8962 22.6694 21.6865C22.6694 23.1382 21.4582 24.1518 19.7144 24.1518H19.723Z"
        fill="#79FF0B"
      />
      <path
        d="M27.995 24.1002C27.7202 24.1002 27.4453 23.9628 27.2391 23.7309L26.2255 22.5369L25.2205 23.748C25.0315 23.98 24.791 24.0916 24.4904 24.0916C23.9664 24.0916 23.5283 23.6535 23.5283 23.1296C23.5283 22.889 23.6314 22.6571 23.8289 22.4252L24.9542 21.1797L23.8805 19.9857C23.6915 19.7881 23.5884 19.539 23.5884 19.2813C23.5884 18.7401 24.0265 18.2935 24.5591 18.2935C24.8683 18.2935 25.126 18.4051 25.3064 18.6285L26.2942 19.831L27.3078 18.6456C27.4882 18.4223 27.7373 18.302 28.038 18.302C28.562 18.302 29 18.7401 29 19.2641C29 19.5046 28.897 19.7366 28.6994 19.9685L27.5569 21.214L28.6736 22.3822C28.8712 22.597 28.9829 22.8461 28.9829 23.1038C28.9829 23.645 28.5276 24.1002 27.995 24.1002Z"
        fill="#79FF0B"
      />
      <path
        d="M41.255 33.0001L41.975 32.2801C43.795 30.4601 43.795 27.5101 41.975 25.7001C41.095 24.8201 39.925 24.3401 38.685 24.3401C37.445 24.3401 36.275 24.8201 35.395 25.7001L34.675 26.4201L33.955 25.7001C33.075 24.8201 31.905 24.3401 30.665 24.3401C29.425 24.3401 28.245 24.8101 27.365 25.6901C25.555 27.5101 25.555 30.4601 27.365 32.2801L28.085 33.0001L27.365 33.7201C25.545 35.5401 25.545 38.4901 27.365 40.3001C28.245 41.1801 29.415 41.6601 30.655 41.6601C31.895 41.6601 33.065 41.1801 33.945 40.3001L34.665 39.5801L35.385 40.3001C36.265 41.1801 37.435 41.6601 38.675 41.6601C39.915 41.6601 41.085 41.1801 41.965 40.3001C43.785 38.4801 43.785 35.5301 41.965 33.7201L41.245 33.0001H41.255Z"
        fill="white"
      />
      <path
        d="M37.6649 33.0002L40.1849 30.4802C41.0149 29.6502 41.0149 28.3102 40.1849 27.4902C39.3549 26.6702 38.0149 26.6602 37.1949 27.4902L34.675 30.0102L32.1549 27.4902C31.3249 26.6602 29.9849 26.6602 29.1649 27.4902C28.3449 28.3202 28.3349 29.6602 29.1649 30.4802L31.6849 33.0002L29.1649 35.5202C28.3349 36.3502 28.3349 37.6902 29.1649 38.5102C29.5749 38.9202 30.1149 39.1302 30.6649 39.1302C31.2149 39.1302 31.7449 38.9202 32.1649 38.5102L34.685 35.9902L37.2049 38.5102C37.6149 38.9202 38.1549 39.1302 38.7049 39.1302C39.2549 39.1302 39.7849 38.9202 40.2049 38.5102C41.0349 37.6802 41.0349 36.3402 40.2049 35.5202L37.6849 33.0002H37.6649Z"
        fill="#FF3F6F"
      />
      <defs>
        <linearGradient
          id={paint0}
          x1="23"
          y1="41"
          x2="23"
          y2="5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00FF00" />
          <stop offset="1" stop-color="#99FF00" />
        </linearGradient>
        <linearGradient
          id={paint1}
          x1="22.9995"
          y1="38.3327"
          x2="22.9995"
          y2="16.7702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#09451E" />
          <stop offset="1" stop-color="#00A000" />
        </linearGradient>
        <linearGradient
          id={paint2}
          x1="22.9998"
          y1="8.62451"
          x2="25"
          y2="41"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00C800" />
          <stop offset="1" stop-color="#007900" />
        </linearGradient>
        <linearGradient
          id={paint3}
          x1="23.957"
          y1="29.7083"
          x2="23.957"
          y2="11.4999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#075818" />
          <stop offset="1" stop-color="#009D0F" />
        </linearGradient>
      </defs>
    </svg>
  )
}
